<template>
    <v-container>
    <div>
        <div class="d-flex align-center my-4">
        <div class="text-h6 font-weight-bold text-left">學校管理</div>
        <v-divider class="flex-grow-1 ml-2"></v-divider>
        <v-btn
          color="black"
          dark
          @click="addSchoolDialog = true"
        >
          新增學校
        </v-btn>
        </div>
        
        <v-simple-table>
        <template v-slot:default>
            <thead>
            <tr>
                <th>學校名稱</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="school in schools" :key="school.id">
                <td class="text-left">{{ school.name }}</td>
                <td class="text-right">
                <v-icon
                    small
                    class="mr-2"
                    @click="editSchool(school)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    small
                    @click="deleteSchool(school)"
                >
                    mdi-delete
                </v-icon>
                </td>
            </tr>
            </tbody>
        </template>
        </v-simple-table>
  </div>
  <v-dialog v-model="addSchoolDialog" max-width="1000px" rounded="lg">
    <v-card class="pa-6">
      <v-card-title class="text-h5 mb-4 text-left">
        新增學校
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="schoolName" label="學校名稱" outlined></v-text-field>
      </v-card-text>
      <v-card-actions class="pt-6">
        <v-spacer></v-spacer>
        <v-btn color="grey" text height="44" @click="addSchoolDialog = false"
            style="border-radius: 10px;width: 15rem;">
            關閉
        </v-btn>
        <v-btn color="black" dark height="44" @click="addSchool"
            style="border-radius: 10px;width: 15rem;">
            完成
        </v-btn>
        <v-spacer></v-spacer>
    </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="editSchoolDialog" max-width="1000px" rounded="lg">
    <v-card class="pa-6" v-if="editingSchool">
      <v-card-title class="text-h5 mb-4 text-left">
        修改學校
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="editingSchool.name" label="學校名稱" outlined></v-text-field>
      </v-card-text>
      <v-card-actions class="pt-6">
        <v-spacer></v-spacer>
        <v-btn color="grey" text height="44" @click="editSchoolDialog = false"
            style="border-radius: 10px;width: 15rem;">
            關閉
        </v-btn>
        <v-btn color="black" dark height="44" @click="updateSchool"
            style="border-radius: 10px;width: 15rem;">
            完成
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="deleteConfirmDialog" max-width="500px">
    <v-card v-if="deletingSchool">
      <v-card-title class="text-h5">確認刪除</v-card-title>
      <v-card-text>
        確定要刪除「{{ deletingSchool.name }}」學校嗎？此操作無法復原。
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="cancelDelete">取消</v-btn>
        <v-btn color="red darken-1" text @click="confirmDelete">確認刪除</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-container>
</template>
<script>
import { SchoolApiService } from '../../services/school.service';

export default {
    name: 'adminSchool',
    data() {
        return {
            addSchoolDialog: false,
            editSchoolDialog: false,
            deleteConfirmDialog: false,
            schoolName: '',
            schools: [],
            editingSchool: null,
            deletingSchool: null
        }
    },
    async created() {
        await this.fetchSchools();
    },
    methods: {
        async fetchSchools() {
            try {
                this.schools = await SchoolApiService.getAllSchools();
            } catch (error) {
                console.error('獲取學校列表失敗:', error);
            }
        },
        async addSchool() {
            try {
                await SchoolApiService.createSchool({ name: this.schoolName });
                await this.fetchSchools();
                this.schoolName = '';
                this.addSchoolDialog = false;
            } catch (error) {
                console.error('新增學校失敗:', error);
            }
        },
        editSchool(school) {
            this.editingSchool = { ...school };
            this.editSchoolDialog = true;
        },
        async updateSchool() {
            try {
                await SchoolApiService.updateSchool(
                    this.editingSchool._id,
                    { name: this.editingSchool.name }
                );
                await this.fetchSchools();
                this.editSchoolDialog = false;
                this.editingSchool = null;
            } catch (error) {
                console.error('更新學校失敗:', error);
            }
        },
        deleteSchool(school) {
            this.deletingSchool = { ...school };
            this.deleteConfirmDialog = true;
        },
        cancelDelete() {
            this.deleteConfirmDialog = false;
            setTimeout(() => {
                this.deletingSchool = null;
            }, 300);
        },
        async confirmDelete() {
            if (!this.deletingSchool) return;
            
            try {
                await SchoolApiService.deleteSchool(this.deletingSchool._id);
                await this.fetchSchools();
                this.deleteConfirmDialog = false;
                setTimeout(() => {
                    this.deletingSchool = null;
                }, 300);
            } catch (error) {
                console.error('刪除學校失敗:', error);
            }
        }
    }
}
</script>

<style scoped>
.v-data-table ::v-deep th {
    font-weight: bold !important;
    color: rgba(0, 0, 0, 0.87) !important;
  }
  
  .v-data-table ::v-deep td {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  
  .v-icon {
    cursor: pointer;
  }
  
  .v-icon:hover {
    opacity: 0.7;
  }
  </style> 